module.exports = __webpack_public_path__ + "img/中国健康管理协会@2x.fbd87f53.png";